<template>
  <div class="table-column"></div>
</template>

<script>
export default {
  name: 'RkTableColumn',
  props: {
    label: {
      type: String,
      default: ''
    },
    prop: {
      type: String,
      default: ''
    },
    width: {
      type: [String]
    },
    align: {
      type: String,
      default: 'right'
    },
    fixed: {
      type: [Boolean, String],
      default: false
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>
